export default __webpack_public_path__ + "media/images/instagram-social-28459038a429affa78ce3c4737018af1.svg";